import { render } from "./OrganisatieView.vue?vue&type=template&id=156032a6&scoped=true"
import script from "./OrganisatieView.vue?vue&type=script&lang=js"
export * from "./OrganisatieView.vue?vue&type=script&lang=js"

import "./OrganisatieView.vue?vue&type=style&index=0&id=156032a6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-156032a6"]])

export default __exports__